import { captureException } from '@sentry/nextjs';

import { IS_PRODUCT } from '@/constants';
import type { TossPixelEventParams } from '@/types/global';

export type TossPixelMethod =
  'pageView' | 'productView' | 'signUp' | 'purchase';

export const TOSS_ADS_CONVERSION_CODE = '3925070476606155723';

//* 문서화된 호출은 TossPixel()뿐이고 _tpq는 번들 내부 큐다 — SDK가 아직 없을 때만 쓴다
const enqueueTossPixelEvent = (
  method: TossPixelMethod,
  params?: TossPixelEventParams,
) => {
  window._tpq = window._tpq ?? [];
  window._tpq.push([
    TOSS_ADS_CONVERSION_CODE,
    method,
    params === undefined ? [] : [params],
  ]);
};

export const trackTossPixelEvent = (
  method: TossPixelMethod,
  params?: TossPixelEventParams,
) => {
  if (!IS_PRODUCT || typeof window === 'undefined') {
    return;
  }

  try {
    const createTossPixel = window.TossPixel;

    if (!createTossPixel) {
      enqueueTossPixelEvent(method, params);

      return;
    }

    createTossPixel(TOSS_ADS_CONVERSION_CODE)[method](params);
  } catch (error) {
    captureException(error);
  }
};

export type { TossPixelEventParams };
